import Box from "@mui/material/Box";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useCallback, useEffect, useRef, useState } from "react";
import HeaderInfo from "../components/dashboardLayout/headerInfo";
import DashboardCard from "../components/dashboardLayout/dashboardCard";
import { getDashboardStatsData } from "../features/dashboardStats/dashboardStatsSlice";
import ListOfExpiredMedCard from "../components/dashboardLayout/listOfExpiredMedCard";
import QuickMonthlyReport from "../components/dashboardLayout/quickMonthlyReport";
import { getQuickReportsData } from "../features/quickReport/quickReportSlice";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../components/common/Loading";
import WelcomeIcon from "../assets/dashboardIcon/welcomeIcon.svg";
import ProfileImage from "../assets/images/profileImage.svg";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import DigitalPinForm from "../components/common/DigitalPinForm";
import AppButton from "../components/common/AppButton";
import {
  AddStaffId,
  getActiveStaff,
  getAllStaffPermissions,
  staffLogout,
  staffLoign,
} from "../features/staff/staffSlice";
import { TypographyPallet, TypographyActive } from "../utils/colorPallet";
import { getShiftDuties } from "../features/shift/shiftSlice";
import ExitButton from "../components/common/ExitButton";
import ExitIcon from "../assets/dashboardIcon/Exit.svg";
import ErrorToster from "../components/common/ErrorToster";
import AppSnackbar from "../components/common/AppSnackbar";
import FreeTrialModal from "../components/packages/freeTrialModel";
import { getStatus } from "../features/subscription/SubscriptionSlice";
import SubscriptionStatusModal from "../components/packages/subscriptionStatusModel";
import PendingSubscriptionStatusModal from "../components/packages/pendingSubscriptionModel";
import PackageScreenComponent from "../components/packages/pricingScreenComponent";
import { SubscriptionEnums } from "../utils/constants";
import { useSelector } from "react-redux";
import DisableModal from "../components/packages/disableModel";
import { DashboardBanner } from "../components/dashboard-screen/dashboard-banner";
import { DashboardWeekSchedule } from "../components/dashboard-screen/dashboard-week-schedule";
import { DashboardShiftRow } from "../components/dashboard-screen/dashboard-shift-row";

export default function Dashboard() {
  const [selectedId, setSelectedId] = useState<number | string>("");
  const handleChange = (event: any) => {
    setSelectedId(event?.target?.value);
  };

  const [selectedMonth, setSelectedMonth] = useState(
    new Date()?.getMonth() + 1
  );
  const [selectedYear, setSelectedYear] = useState(new Date()?.getFullYear());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const [pharmacyId, setPharmacyId] = useState<any>();
  const [staffLogoutState, setStaffLogoutState] = useState<any>(false);
  const [openErrorToast, setOpenErrorToast] = useState<any>(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState<any>([]);
  const [modalOpenPendingSub, setModalOpenPendingSub] = useState(false);
  const [PendingSub, setPendingSub] = useState(false);
  const [modalOpenExpSub, setModalOpenExpSub] = useState(false);
  const [modalActiveSub, setModalActiveSub] = useState(false);
  const [active, setActive] = useState(false);
  const [modalReject, setModalReject] = useState(false);
  const [rejected, setRejected] = useState(false);
  const [modalTerminate, setModalTerminate] = useState(false);
  const [terminate, setTerminate] = useState(false);
  const [openSubScreen, setOpenSubScreen] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [isSubscription, setIsSubscription] = useState<any>(false);
  const [disableModal, setDisableModal] = useState(false);
  const [modalOpenFree, setModalOpenFree] = useState(false);
  const handleModalOpenFree = () => {
    setModalOpenFree(true);
  };

  const handleModalCloseFree = () => {
    setModalOpenFree(false);
    localStorage.removeItem("subscription_type");
  };

  // const Account_Type: number = 1;

  const Account_Type = parseInt(
    localStorage?.getItem("pharmacy_account_type") || "0",
    10
  );

  const {
    staffPermissionsPayload,
    activeStaffPayload,
    staffLoginMessage,
  }: any = useAppSelector((state) => state?.staff);

  const currentDate = new Date();
  const formattedDate = currentDate?.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const { shiftDutiesPayload }: any = useAppSelector((state) => state?.shift);
  const ShiftDuties = shiftDutiesPayload?.staff_duty_with_roles;

  // Filter active staff
  const activeStaffData = activeStaffPayload?.filter(
    (item: any) => item?.check_out === null
  );

  const updatedActiveStaffData = activeStaffData?.map((activeItem: any) => {
    const matchingShiftDuty = ShiftDuties?.find(
      (shiftDuty: any) =>
        shiftDuty?.pharmacyStaff?.id === activeItem?.pharmacyStaff?.id
    );
    if (matchingShiftDuty) {
      return {
        ...activeItem,
        start_time: matchingShiftDuty?.start_time,
        end_time: matchingShiftDuty?.end_time,
      };
    }
    return activeItem;
  });

  const staffName = updatedActiveStaffData[0]?.pharmacyStaff?.name;
  localStorage.setItem("UserName", staffName);
  

  const handleCalender = () => {
    setIsCalendarOpen(true);
  };

  const dispatch = useAppDispatch();
  const staff_data = localStorage?.getItem("staff_data");
  const StaffData = staff_data ? JSON?.parse(staff_data) : null;
  const [staffId, setStaffId] = useState(StaffData?.id ? StaffData?.id : null);
  const StaffDuties: any = ShiftDuties?.filter(
    (item: any) => item?.pharmacyStaff?.id === staffId
  );

  useEffect(() => {
    const pharmacy_Id: any = localStorage?.getItem("pharmacyId");

    if (StaffData) {
      const obj: any = {
        pharmacy_id: pharmacy_Id,
        staff_id: StaffData?.id,
      };
      dispatch(getActiveStaff(obj));
      dispatch(getShiftDuties(pharmacy_Id));
      setStaffLogoutState(true);
    }
  }, [dispatch, StaffData?.id]);

  const { isStaffLoginLoading } = useAppSelector((state: any) => state?.staff);

  const getPharmacyId = async () => {
    try {
      // Simulate a delay before retrieving data
      await new Promise((resolve) => setTimeout(resolve, 100));
      const pharmacy_Id = await localStorage?.getItem("pharmacyId");
      if (pharmacy_Id) {
        setPharmacyId(pharmacy_Id);
      } else {
      }
      setPharmacyId(pharmacy_Id);
    } catch (error) {
      console.error("Error getting pharmacy ID: ", error);
    }
  };

  const pharmacyID: any = localStorage?.getItem("pharmacyId");

  const GetAllStaffPermissions = useCallback(() => {
    dispatch(getAllStaffPermissions(pharmacyID));
  }, [dispatch]);

  useEffect(() => {
    if (pharmacyID) {
      GetAllStaffPermissions();
    }
  }, [pharmacyID, GetAllStaffPermissions]);

  const options = staffPermissionsPayload
    ? staffPermissionsPayload?.map((item: any) => ({
        id: item?.staff?.id,
        name:
          item?.staff?.name?.charAt(0)?.toUpperCase() +
          item?.staff?.name?.slice(1)?.toLowerCase(),
      }))
    : [];

  const formRef = useRef<any>(null);

  const handleEndShift = () => {
    const Barer_Token = StaffData?.token;

    dispatch(staffLogout(Barer_Token))?.then((res: any) => {
      if (res?.payload?.success === true) {
        setStaffLogoutState(false);
        setOpenSnackbar(false);
        dispatch(AddStaffId(null));
        localStorage?.removeItem("staff_data");
      }
    });
  };

  const handleSubmit = (pin: any) => {
    const obj: any = {
      pharmacy_id: pharmacyId,
      id: selectedId,
      pin: pin,
    };

    dispatch(staffLoign(obj))?.then((res: any) => {
      if (res?.payload?.success === true) {
        const data = res?.payload?.data;
        if (data) {
          localStorage?.setItem("staff_data", JSON?.stringify(data));
          dispatch(AddStaffId(data?.id));
          setStaffId(data?.id);
        }
        const obj: any = {
          staff_id: data?.id,
          pharmacy_id: pharmacyID,
        };
        dispatch(getActiveStaff(obj));
        dispatch(getShiftDuties(pharmacyID));
        setStaffLogoutState(true);
      } else {
        setOpenErrorToast(true);
      }
    });
  };

  const getDashboardStats = () => {
    if (pharmacyId) {
      dispatch(getDashboardStatsData(pharmacyId));
    }
  };
  const getQuickReports = () => {
    if (pharmacyId) {
      dispatch(
        getQuickReportsData({
          pharmacyId: pharmacyId,
          month: selectedMonth,
          year: selectedYear,
        })
      );
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    await getPharmacyId();
    await getDashboardStats();
    await getQuickReports();
    setTimeout(() => {
      setIsLoading(false);
    }, 1200);
  };
  useEffect(() => {
    fetchData();
  }, [pharmacyId]);

  const rowData: any = useAppSelector((state) => state?.dashboardStats);
  const quickReportData: any = useAppSelector((state) => state?.quickReports);
  const batchesInStock = rowData?.dashboardStatsDetails?.avaialable_batchs;
  const batchesOutStock = rowData?.dashboardStatsDetails?.out_of_stock_batchs;
  const expiredBatches = rowData?.dashboardStatsDetails?.expired_batches;
  const frequentlyBought = rowData?.dashboardStatsDetails?.frequently_bought_med
    ?.map((frequentBought: any) => frequentBought?.medicine_name)
    ?.join(", ");

  const batchesOverviewData = [
    {
      title: "Batches in Stock",
      totalMedicines: batchesInStock ? batchesInStock : 0,
      medicineGroups: 4,
    },
    {
      title: "Batches out of Stock",
      totalMedicines: batchesOutStock ? batchesOutStock : 0,
      medicineGroups: 3,
    },
    {
      title: "Expired Batches",
      totalMedicines: expiredBatches ? expiredBatches : 0,
      medicineGroups: 4,
    },
    {
      title: "Frequently bought Item(s)",
      totalMedicines: frequentlyBought ? frequentlyBought : 0,
      medicineGroups: 3,
    },
  ];

  const listOfExpiredBatchesData = [
    {
      expiredBatchNumbers:
        rowData?.dashboardStatsDetails?.expired_medicine_batches?.map(
          (batch: any) => batch?.batch_no
        ),
      expiryDate: rowData?.dashboardStatsDetails?.expired_medicine_batches?.map(
        (batch: any) => batch?.expiry_date
      ),
      expiredname:
        rowData?.dashboardStatsDetails?.expired_medicine_batches?.map(
          (batch: any) => batch?.pharmacy_medicine?.name
        ),
    },
  ];

  const medicineSold = quickReportData?.quickReportsDetails?.medicines_sold;
  const totalInvoiceGenrated =
    quickReportData?.quickReportsDetails?.total_invoice_genrated;

  const quickMonthlyReportData = [
    {
      title: "Qty of Products Sold",
      totalMedicines: medicineSold ? medicineSold : 0,
      medicineGroups: 4,
    },
    {
      title: "Invoices Generated",
      totalMedicines: totalInvoiceGenrated ? totalInvoiceGenrated : 0,
      medicineGroups: 3,
    },
  ];
  const navigate = useNavigate();
  const handlexpireMedBatch = () => {
    navigate("/dashboard/batch", { state: { fromExpireMedBatch: true } });
  };

  const handleBatch = () => {
    navigate("/dashboard/batch");
  };

  const getSubscriptionStatus = useCallback(() => {
    dispatch(getStatus(pharmacyID))
      ?.then((res: any) => {
        setSubscriptionStatus(res); // Store the response in state
        setSubscriptionId(res?.payload?.active_subscription?.[0]?.id);
        setIsSubscription(res?.payload?.active_subscription?.[0]?.open_model);
      })
      ?.catch((error) => {
        console.error("Error fetching subscription status:", error);
      });
  }, [dispatch, pharmacyID]);

  // Trigger the subscription check when the screen loads
  useEffect(() => {
    getSubscriptionStatus();
  }, [getSubscriptionStatus]);

  const handleModalOpenExpSub = () => {
    setModalOpenExpSub(true);
  };

  const handleModalCloseExpSub = () => {
    setModalOpenExpSub(false);
    localStorage.removeItem("subscription_type");
  };

  const handleModalOpenReject = () => {
    setModalReject(true);
    setRejected(true);
  };

  const handleModalCloseReject = () => {
    setModalReject(false);
    localStorage.removeItem("subscription_type");
  };

  const handleModalOpenTerminate = () => {
    setModalTerminate(true);
    setTerminate(true);
  };

  const handleModalCloseTerminate = () => {
    setModalTerminate(false);
    localStorage.removeItem("subscription_type");
  };

  const handleModalOpenActiveSub = () => {
    setModalActiveSub(true);
    setActive(true);
  };

  const handleModalCloseActiveSub = () => {
    setModalActiveSub(false);
    localStorage.removeItem("subscription_type");
  };

  const handleModalOpenPendingSub = () => {
    setModalOpenPendingSub(true);
    setPendingSub(true);
  };

  const handleModalClosePendingSub = () => {
    setModalOpenPendingSub(false);
    localStorage.removeItem("subscription_type");
  };

  const handleOpenSubScreen = () => {
    setOpenSubScreen(true);
  };

  const handleCloseSubScreen = () => {
    setOpenSubScreen(false);
  };

  // useEffect(() => {
  //   if (
  //     subscriptionStatus?.payload?.current_subscription_status ===
  //     SubscriptionEnums?.NOSUBSCRIPTION
  //   ) {
  //     handleOpenSubScreen();
  //   } else if (
  //     subscriptionStatus?.payload?.current_subscription_status ===
  //     SubscriptionEnums?.EXPIRED
  //   ) {
  //     handleModalOpenExpSub();
  //   } else if (
  //     subscriptionStatus?.payload?.current_subscription_status ===
  //     SubscriptionEnums?.PENDING
  //   ) {
  //     handleModalOpenPendingSub();
  //   } else if (
  //     subscriptionStatus?.payload?.current_subscription_status ===
  //     SubscriptionEnums?.REJECT
  //   ) {
  //     handleModalOpenReject();
  //   } else if (
  //     subscriptionStatus?.payload?.current_subscription_status ===
  //       SubscriptionEnums?.ACTIVE &&
  //     isSubscription === true
  //   ) {
  //     handleModalOpenActiveSub();
  //   } else if (
  //     subscriptionStatus?.payload?.current_subscription_status ===
  //     SubscriptionEnums?.TERMINATE
  //   ) {
  //     handleModalOpenTerminate();
  //   }
  // }, [subscriptionStatus]);

  // useEffect(() => {
  //   const subscriptionType = localStorage.getItem("subscription_type");
  //   if (subscriptionType === "1") {
  //     handleModalOpenFree(); // Automatically open the modal if subscription_type is 1
  //   }
  // }, []);

  const handleOpenDisableModal = () => {
    setDisableModal(true);
  };

  const handleCloseDisableModal = () => {
    setDisableModal(false);
    localStorage.removeItem("subscription_type");
  };

  useEffect(() => {
    if (subscriptionStatus?.payload?.current_status === 2) {
      handleOpenDisableModal();
    }
  }, [subscriptionStatus]);

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75vh", // Set height to full viewport height
          }}
        >
          <LoadingSpinner />
        </Box>
      ) : (
        <>
          {/* <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 2,
            }}
          >
            <Box sx={{ fontSize: "24px", fontWeight: "bold" }}>Dashboard</Box>
          </Box> */}

          {/**  Admin Dashboard Start */}

          {Account_Type === 0 ? (
            <Box
              style={{
                margin: "10px",
                marginLeft: "15px",
                backgroundColor: "white",
                borderRadius: "5px",
              }}
            >
              <Box sx={{ px: 2.5 }}>
                <HeaderInfo doctorStats={rowData} />
              </Box>
              <Box
                style={{
                  margin: "10px",
                  marginLeft: "10px",
                  backgroundColor: "white",
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    margin: "10px",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 2,
                  }}
                >
                  <ListOfExpiredMedCard
                    data={listOfExpiredBatchesData}
                    title={"List of Expired Medicine Batch"}
                    buttonTitle={"View Expired Batches"}
                    onClick={handlexpireMedBatch}
                  />

                  <QuickMonthlyReport
                    data={quickMonthlyReportData}
                    title={"Quick Monthly Report"}
                    buttonTitle={"Calender"}
                    onClick={handleCalender}
                  />
                </Box>
                <Box style={{ margin: "10px", marginTop: "25px" }}>
                  <DashboardCard
                    data={batchesOverviewData}
                    title={"Medicine Batches Overview"}
                    buttonTitle={"Go to Batch Management"}
                    onClick={handleBatch}
                  />
                </Box>
              </Box>
            </Box>
          ) : Account_Type === 1 ? (
            <>
              {updatedActiveStaffData?.length > 0 && staffLogoutState ? (
                <>
                  <DashboardBanner
                    handleEndButtonModal={handleEndShift}
                    name={updatedActiveStaffData[0]?.pharmacyStaff?.name}
                    logoutState={staffLogoutState}
                    staffId={staffId}
                  />
                  {/* <Box
                    sx={{
                      margin: "10px",
                      marginLeft: "15px",
                      backgroundColor: "white",
                      borderRadius: "5px",
                    }}
                  >
                   
                    <Box
                      sx={{
                        width: "100%",
                        px: 2.5,
                        py: 2,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          py: 2,
                        }}
                      >
                        <Typography sx={{ ...TypographyPallet?.body3 }}>
                          Ongoing Shift
                        </Typography>
                        <Typography sx={{ ...TypographyPallet?.body4 }}>
                          {new Date(
                            activeStaffData[0]?.check_in
                          )?.toLocaleDateString("en-GB", {
                            weekday: "long",
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </Typography>
                      </Box>

                      {updatedActiveStaffData?.map(
                        (item: any, index: number) => (
                          <Box
                            key={index}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              border: "0.5px solid #E0E0E0",
                              backgroundColor: "#FAFAFA",
                              padding: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <img
                                src={
                                  ProfileImage || "path/to/default-image.png"
                                }
                                alt="Avatar"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  objectFit: "cover",
                                }}
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography sx={{ ...TypographyPallet?.body1 }}>
                                  {item?.pharmacyStaff?.name}
                                </Typography>
                                <Typography sx={{ ...TypographyPallet?.body2 }}>
                                  {item?.pharmacyStaff?.email}
                                </Typography>
                              </Box>
                            </Box>
                            <Typography sx={{ ...TypographyPallet?.body1 }}>
                              {new Date(item?.check_in)?.toLocaleDateString(
                                "en-GB"
                              )}
                            </Typography>
                            <Typography sx={{ ...TypographyPallet?.body1 }}>
                              {item?.start_time || "-"}
                            </Typography>
                            <Typography sx={{ ...TypographyPallet?.body1 }}>
                              {item?.end_time || "-"}
                            </Typography>
                            <Typography
                              sx={{
                                ...TypographyActive?.body1,
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <span
                                style={{
                                  width: "5px",
                                  height: "5px",
                                  borderRadius: "50%",
                                  backgroundColor: "currentColor",
                                  display: "inline-block",
                                }}
                              ></span>
                              Active
                            </Typography>
                          </Box>
                        )
                      )}
                    </Box>

                  

                    <Box
                      sx={{
                        width: "100%",
                        px: 2.5,
                        py: 2,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          py: 2,
                        }}
                      >
                        <Typography sx={{ ...TypographyPallet?.body3 }}>
                          Upcoming Shift
                        </Typography>
                        <Typography sx={{ ...TypographyPallet?.body4 }}>
                          {new Date(
                            ShiftDuties[0]?.created_at
                          )?.toLocaleDateString("en-GB", {
                            weekday: "long",
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </Typography>
                      </Box>

                      {ShiftDuties?.map((item: any, index: number) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            border: "0.5px solid #E0E0E0",
                            backgroundColor: "#FAFAFA",
                            padding: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <img
                              src={ProfileImage || "path/to/default-image.png"}
                              alt="Avatar"
                              style={{
                                width: "30px",
                                height: "30px",
                                objectFit: "cover",
                              }}
                            />
                            <Box
                              sx={{ display: "flex", flexDirection: "column" }}
                            >
                              <Typography sx={{ ...TypographyPallet?.body1 }}>
                                {item?.pharmacyStaff?.name}
                              </Typography>
                              <Typography sx={{ ...TypographyPallet?.body2 }}>
                                {item?.pharmacyStaff?.email}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography sx={{ ...TypographyPallet?.body1 }}>
                            {new Date(item?.created_at)?.toLocaleDateString(
                              "en-GB"
                            )}
                           
                          </Typography>
                          <Typography sx={{ ...TypographyPallet?.body1 }}>
                            {item?.start_time || "-"}{" "}
                          
                          </Typography>
                          <Typography sx={{ ...TypographyPallet?.body1 }}>
                            {item?.end_time || "-"}{" "}
                        
                          </Typography>

                          <Typography
                            sx={{
                              ...TypographyActive?.progress,
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <span
                              style={{
                                width: "5px",
                                height: "5px",
                                borderRadius: "50%",
                                backgroundColor: "currentColor",
                                display: "inline-block",
                              }}
                            >
                              .
                            </span>
                            In Progress
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    
                  </Box> */}

                  <Box
                    style={{
                      margin: "10px",
                      marginLeft: "15px",
                      backgroundColor: "white",
                      borderRadius: "20px",
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          padding: "16px 32px",
                          borderBottom: "1px solid #D9D9D9",
                        }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontWeight: "500",
                            fontSize: "18px",
                            lineHeight: "27px",
                            alignContent: "center",
                          }}
                        >
                          Shift Details
                        </Typography>

                        <Box
                          sx={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "21px",
                            color: "#2C323D",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "10px",
                            border: "1px solid #D9D9D9",
                            height: "37px",
                            marginLeft: "20px",
                            padding: "8px 12px",
                          }}
                        >
                          THIS WEEK
                        </Box>
                      </Box>
                      <DashboardWeekSchedule StaffDuties={StaffDuties} />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          padding: "16px 32px",
                        }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            color: "#2C323D",
                            fontWeight: "500",
                            fontSize: "18px",
                            lineHeight: "27px",
                            alignContent: "center",
                          }}
                        >
                          Upcoming Shift
                        </Typography>

                        <Box
                          sx={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "21px",
                            color: "#2C323D",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "10px",
                            border: "1px solid #D9D9D9",
                            height: "37px",
                            marginLeft: "20px",
                            padding: "8px 12px",
                          }}
                        >
                          {formattedDate}
                        </Box>
                      </Box>
                      <Box
                        sx={{ width: "100%", margin: "auto", height: "50vh" }}
                      >
                        <DashboardShiftRow
                          ShiftDuties={ShiftDuties}
                          formattedDate={formattedDate}
                        />
                      </Box>
                    </Box>
                  </Box>
                </>
              ) : (
                <>
                  <DashboardBanner
                    handleEndButtonModal={handleEndShift}
                    name={activeStaffData?.[0]?.pharmacyStaff?.name}
                    logoutState={staffLogoutState}
                  />
                  <Box
                    style={{
                      margin: "10px",
                      marginLeft: "15px",
                      backgroundColor: "white",
                      borderRadius: "5px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          pr: { xs: 0, sm: 15 },
                        }}
                      >
                        <Box>
                          <img src={WelcomeIcon} alt="Welcome" />
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: { xs: "35px", sm: "64px" },
                              fontWeight: "600",
                              lineHeight: "22px",
                              textColor: "#333333",
                            }}
                          >
                            {"Welcome!"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: { xs: 300, sm: 400 } }}>
                          <Typography
                            sx={{ textAlign: "start", mb: 1 }}
                            variant="body1"
                          >
                            {"Select User"}
                          </Typography>
                          <FormControl fullWidth>
                            <Select
                              value={selectedId}
                              onChange={handleChange}
                              displayEmpty
                              defaultValue=""
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 200,
                                    overflowY: "auto",
                                  },
                                },
                              }}
                            >
                              <MenuItem value="" disabled>
                                Select User
                              </MenuItem>
                              {options?.map((option: any) => (
                                <MenuItem key={option?.id} value={option?.id}>
                                  {option?.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>

                        <Box
                          sx={{
                            mt: 2,
                          }}
                        >
                          <DigitalPinForm
                            title="Enter your 6 digit pin to access employee portal"
                            length={6}
                            onSubmit={handleSubmit}
                            ref={formRef}
                          />
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mb: 10,
                          }}
                        >
                          <AppButton
                            sx={{ mt: 3 }}
                            variant="contained"
                            color="primary"
                            type="button"
                            title={"Start"}
                            onClick={() => formRef?.current?.submitForm()}
                            disabled={isStaffLoginLoading || selectedId === ""}
                          />
                        </Box>

                        <ErrorToster
                          message={staffLoginMessage}
                          open={openErrorToast}
                          handleClose={() => setOpenErrorToast(false)}
                        />

                        <AppSnackbar
                          message="Successfully Login!"
                          open={openSnackbar}
                          handleClose={() => setOpenSnackbar(false)}
                        />
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </>
          ) : null}

          {/**  Admin Dashboard End */}

          {/**  Employee Dashboard Start */}

          {/**  Employee Dashboard End */}
        </>
      )}
      <DisableModal open={disableModal} onClose={handleCloseDisableModal} />
      {/* <FreeTrialModal open={modalOpenFree} onClose={handleModalCloseFree} /> */}
      {/* <SubscriptionStatusModal
        open={modalOpenExpSub}
        onClose={handleModalCloseExpSub}
      /> */}
      {/* <PendingSubscriptionStatusModal
        open={
          PendingSub
            ? modalOpenPendingSub
            : rejected
            ? modalReject
            : active
            ? modalActiveSub
            : terminate
            ? modalTerminate
            : null
        }
        onClose={handleModalCloseActiveSub}
        PendingSub={PendingSub}
        rejected={rejected}
        terminate={terminate}
        active={active}
        subscriptionId={subscriptionId}
      /> */}
      {/* <PackageScreenComponent
        open={openSubScreen}
        onClose={handleCloseSubScreen}
      /> */}
    </>
  );
}
